let date = new Date();
date.setDate(1);
export default function (state, value) {
    let item = {
        id: ''+new Date().getTime(),
        name: 'Фильтр ' + (state.filters.length + 1),
        searchClick: true,
        dateStep: 1,
        dateInt: 0,
        dateRound: false,
        AccountId: '',
        SubAccountId: '',
        ContragentId: '',
        ContragentName: '',
        CurrencyId: '',
        PaymentAccountId: '',
        WithTurns: false,
        WithDocumens: false,
    };
    if (value) {
        for (let k in value) {
            if (typeof item[k] !== 'undefined') item[k] = value[k];
        }
    }
    state.filters.push(item);
    if (!value) {
        state.filter = item.id;
    }
}